import { DateTime } from 'luxon';
import { v4 as uuidv4 } from 'uuid';

const postedTransactions = (account) => {
  const postedOnDate = DateTime.local().minus({ days: 1 });
  const postedOn = postedOnDate.toISODate();
  const cpId = uuidv4();

  return [
    {
      source: 'QCS_REFRESH',
      accountId: account?.id,
      postedOn,
      payee: 'Tesla Inc',
      coa: {
        type: 'UNCATEGORIZED',
        id: '0',
      },
      amount: -11.22,
      state: 'CLEARED',
      matchState: 'NOT_MATCHED',
      cpData: {
        id: cpId,
        cpPendingId: cpId,
        postedOn,
        txnOn: postedOn,
        amount: -11.22,
        payee: 'TESLA INC SUPERCHARGPALO ALTO',
        inferredPayee: 'Tesla Inc',
        inferredCoa: {
          type: 'UNCATEGORIZED',
          id: '0',
        },
        cpCategoryId: '2002',
      },
      type: 'CASH_FLOW',
    },
    {
      source: 'QCS_REFRESH',
      accountId: account?.id,
      postedOn,
      payee: 'Safeway Grocceries',
      coa: {
        type: 'UNCATEGORIZED',
        id: '0',
      },
      amount: -56.78,
      state: 'CLEARED',
      matchState: 'NOT_MATCHED',
      cpData: {
        id: cpId,
        cpPendingId: cpId,
        postedOn,
        txnOn: postedOn,
        amount: -56.78,
        payee: 'Safeway423 MV23',
        inferredPayee: 'Safeway MV',
        inferredCoa: {
          type: 'UNCATEGORIZED',
          id: '0',
        },
        cpCategoryId: '2002',
      },
      type: 'CASH_FLOW',
    },
    {
      source: 'QCS_REFRESH',
      accountId: account?.id,
      postedOn,
      payee: 'Safeway Gas',
      coa: {
        type: 'UNCATEGORIZED',
        id: '0',
      },
      amount: -12.34,
      state: 'CLEARED',
      matchState: 'NOT_MATCHED',
      cpData: {
        id: `${cpId}1`,
        cpPendingId: `${cpId}1`,
        postedOn,
        txnOn: postedOn,
        amount: -12.34,
        payee: 'SAFEWAY32 GAS PALOALTO43',
        inferredPayee: 'Safeway Gas',
        inferredCoa: {
          type: 'UNCATEGORIZED',
          id: '0',
        },
        cpCategoryId: '2002',
      },
      type: 'CASH_FLOW',
    },
    {
      source: 'QCS_REFRESH',
      accountId: account?.id,
      postedOn,
      payee: 'Safeway Refund',
      coa: {
        type: 'UNCATEGORIZED',
        id: '0',
      },
      amount: +56.78,
      state: 'CLEARED',
      matchState: 'NOT_MATCHED',
      cpData: {
        id: `${cpId}2`,
        cpPendingId: `${cpId}2`,
        postedOn,
        txnOn: postedOn,
        amount: +56.78,
        payee: 'SAFEWAY32 ONLINE43',
        inferredPayee: 'Safeway Refund',
        inferredCoa: {
          type: 'UNCATEGORIZED',
          id: '0',
        },
        cpCategoryId: '2002',
      },
      type: 'CASH_FLOW',
    },
  ];
};

export default postedTransactions;
